// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// SaveSelfStudyTemplateHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import SelfStudyTemplateDTO from '../models/SelfStudyTemplateDTO';
import ResultDTO from '../models/ResultDTO';

interface Request {
    academicYear: number;
    selfStudy: SelfStudyTemplateDTO | null;
    finalize: boolean;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            academicYear: 0,
            selfStudy: null,
            finalize: false,
        },
        initValues);
    },
    academicYear: 'academicYear',
    selfStudy: 'selfStudy',
    finalize: 'finalize',
}

interface Result extends ResultDTO {
    selfStudy: SelfStudyTemplateDTO | null;
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
            selfStudy: null,
        },
        initValues);
    },
    selfStudy: 'selfStudy',
}

export { Request, Result };